import React from 'react';
import { connect } from 'react-redux';
import {
    toggleShowAddOrgUnitContact,
    fetchContactTypes,
    addOrgUnitContact
} from './../../../reduxFiles/actionTypes';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import contactIcon from './../phone-book.svg';
import { Item, Segment, Form, Input, Dropdown, Button, Label, Icon } from 'semantic-ui-react';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

class OrgUnitContact extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            contactType: {
                id: null
            },
            description: ''
        };

        if (this.props.isAddingContact) {
            this.props.dispatch(toggleShowAddOrgUnitContact());
        }

        this.showAddContact = this.showAddContact.bind(this);
        this.addContact = this.addContact.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.addingContactSuccess) {
            this.setState({
                value: '',
                contactType: {
                    id: null
                },
                description: ''
            });
        }

        if (this.props.orgUnitId !== nextProps.orgUnitId && this.props.isAddingContact) {
            this.props.dispatch(toggleShowAddOrgUnitContact());
        }
    }

    showAddContact() {
        this.props.dispatch(fetchContactTypes());
        this.props.dispatch(toggleShowAddOrgUnitContact());
    }

    addContact() {
        const orgUnitContact = {
            value: this.state.value,
            description: this.state.description,
            contactType: this.state.contactType
        }
        const {orgUnitId} = this.props;

        this.props.dispatch(addOrgUnitContact(orgUnitId, orgUnitContact));
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value })

    render() {
        const {isAddingContact, contactTypes, addingStaffError} = this.props;

        if (contactTypes.error) {
            toast(<FormattedMessage id='orgUnitDetailed.errors.gettingContactType'/>);
        }
        if (addingStaffError) {
            toast(<FormattedMessage id='orgUnitDetailed.errors.addingContact'/>);
        }

        return (
            <Item>
                <Item.Image src={contactIcon} size='tiny'/>
                <Item.Content style={{paddingRight: '21px'}}>
                    <Item.Header><AddContact showAddContact={this.showAddContact}/></Item.Header>
                    <Item.Description>
                        {isAddingContact &&
                            <Segment raised>
                                <Form>
                                    <Form.Field>
                                        <label><FormattedMessage id='orgUnitDetailed.contactValue'/></label>
                                        <Input name='value' value={this.state.value} onChange={this.handleChange} />
                                    </Form.Field>

                                    <Form.Field>
                                        <label><FormattedMessage id='orgUnitDetailed.contactType'/></label>
                                        <Dropdown clearable
                                            onChange={(e, {value}) => this.setState({ contactType: {
                                                                                            id: value
                                                                                        } })}
                                            fluid
                                            selection
                                            value={this.state.contactType.id}
                                            options={contactTypes.items.map(contactType =>
                                                ({ key: contactType.id, value: contactType.id, text: contactType.name })
                                            )}/>
                                    </Form.Field>

                                    <Form.Field>
                                        <label><FormattedMessage id='orgUnitDetailed.contactDescription'/></label>
                                        <Input name='description' value={this.state.description} onChange={this.handleChange} />
                                    </Form.Field>
                                    <Icon circular name='check' onClick={this.addContact}/>
                                    <Icon circular name='cancel' onClick={() => {this.props.dispatch(toggleShowAddOrgUnitContact());}}/>
                                </Form>
                            </Segment>
                        }
                        <div className="ui bulleted list" >
                            {this.props.contacts.map((contact, index) =>
                                <Contact key={index} contact={contact}/>
                            )}
                        </div>
                    </Item.Description>
                </Item.Content>
            </Item>
        )
    }
}

class Contact extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isDeleteContactVisibile: 'hidden'
        }
    }

    delete = (event) => {
        const contactid = this.props.contact.id;
        axios.delete(`/organizational-units/contacts/${contactid}`)
        .then(response => {
            // TODO emir: notify user and refresh contacts
        }).catch(error => {
            toast(<FormattedMessage id='orgUnitDetailed.errors.deletingContact'/>);
        });
    }

    render() {
        return (
        <div className="item" style={{display: 'flex', justifyContent: 'space-between'}}
                onMouseOver={() => {this.setState({isDeleteContactVisibile : 'visible'})}}
                onMouseOut={() => {this.setState({isDeleteContactVisibile : 'hidden'})}}>

            <div>
                <div>{this.props.contact.value}</div>
                <div>{this.props.contact.description}</div>
                <div>{this.props.contact.contactTypeName}</div>
            </div>

            <div style={{display: 'flex', visibility: this.state.isDeleteContactVisibile}}>
                <Icon circular name='minus' onClick={this.delete}/>
            </div>
        </div>)
    }
}

const AddContact = (props) => (
    <Button as='div' labelPosition='left' onClick={(event, data) => {props.showAddContact()}}>
        <Label as='a' basic pointing='right'><FormattedMessage id='orgUnitDetailed.contacts'/></Label>
        <Button icon>
            <Icon name='plus' />
        </Button>
    </Button>
)

function mapStateToProps(state) {
    return {
        isAddingContact: state.ui.orgUnitsView.contactView.isAddingContact,
        contactTypes: state.ui.orgUnitsView.contactView.contactTypes,
        isSendingContact: state.ui.orgUnitsView.contactView.isSendingContact,
        addingContactError: state.ui.orgUnitsView.contactView.addingContactError,
        addingContactSuccess: state.ui.orgUnitsView.contactView.addingContactSuccess
    }
}

export default connect(mapStateToProps)(OrgUnitContact);



// WEBPACK FOOTER //
// ./src/views/OrganizationalUnit/components/OrgUnitContact.js